// extracted by mini-css-extract-plugin
export default {"tiny":"4px","tiny2":"5px","small":"8px","small2":"10px","small3":"12px","medium":"16px","medium2":"20px","large":"24px","large2":"30px","large3":"40px","large4":"60px"};